import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import ErrorReducer from './error';
import MyRouterReducer from './myRouter';
import AcademiesReducer from './academies'
import MateriasReducer from './materias'
import UsersReducer from './users';
import UsuariosReducer from './usuarios';
import ExamenesReducer from './examenes';
import PreguntasReducer from './preguntas';
import ForosReducer from './foros';

export const RESET_USER = 'RESET_USER';

const rootReducers = history => combineReducers({
    error: ErrorReducer,
    myRouter: MyRouterReducer,
    router: connectRouter(history),
    academies: AcademiesReducer,
    materias: MateriasReducer,
    users: UsersReducer,
    usuarios: UsuariosReducer,
    examenes: ExamenesReducer,
    preguntas: PreguntasReducer,
    foros: ForosReducer
});

export default rootReducers;
